

<mat-form-field class="full-width">

  <mat-label ssFormLabel></mat-label>
  <ss-date-control></ss-date-control>
  <!-- <mat-hint>{{formatSubject | async}}</mat-hint> -->
  <mat-error ssFormValidationMessage></mat-error>

</mat-form-field>
